import { render, staticRenderFns } from "./contactDetail.vue?vue&type=template&id=2bdb9802&scoped=true"
import script from "./contactDetail.vue?vue&type=script&lang=js"
export * from "./contactDetail.vue?vue&type=script&lang=js"
import style0 from "./contactDetail.vue?vue&type=style&index=0&id=2bdb9802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb9802",
  null
  
)

export default component.exports